module.exports = require("babel-helper-vue-jsx-merge-props");